export default "__VITE_ASSET__db01a693__"